import React from "react";
import { Wallet, Receipt, BarChart3, NotebookPen } from "lucide-react";
import { Link } from "react-router-dom";
import MerkezHubShell from "@/components/MerkezHubShell";

const TABS = [
    { id: "kasa", label: "Kasa & Transfer", icon: Wallet },
    { id: "odeme-raporlari", label: "Ödeme Raporları", icon: Receipt },
    { id: "kar-zarar", label: "Kar / Zarar", icon: BarChart3 },
    { id: "defterler", label: "Hesap Defterleri", icon: NotebookPen },
];

export function FinansDefterlerTab() {
    return (
        <div className="p-6 max-w-3xl">
            <div className="rounded-2xl border border-white/10 bg-[#0a1018]/80 p-6">
                <h2 className="text-lg font-semibold text-white">Hesap Defterleri</h2>
                <p className="text-sm text-slate-500 mt-2">
                    Kasa kartları ve defter kayıtları klasik entity ekranında yönetilir.
                </p>
                <Link
                    to="/e/hesap-defterleri"
                    className="mt-5 inline-flex items-center gap-2 rounded-xl bg-[#D4AF37] px-4 py-2.5 text-sm font-bold text-slate-900"
                >
                    <NotebookPen className="h-4 w-4" />
                    Hesap defterlerini aç
                </Link>
            </div>
        </div>
    );
}

export default function FinansMerkezLayout() {
    return (
        <MerkezHubShell
            title="Finans Merkezi"
            subtitle="Kasa, ödeme raporları, kar/zarar ve hesap defterleri tek finans komutasında."
            badge="Finans · Nakit & P&L"
            basePath="/yeni/finans-merkezi"
            tabs={TABS}
        />
    );
}
